export default function mapFromFirstRow(prefix, row, fields) {
  const fieldNames = fields.map(field => field.get('name'));
  row.forEach((column, key) => {
    if (fieldNames.includes(column)) {
      this.dsAdd('set', prefix + '/' + key, column);
    }
  })
}